/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-18 9:03:18
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Button, Card, Layout, Page } from '@shopify/polaris';

import TitleHelp from 'src/components/views/common/title-help';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { URL } from 'src/constants/links';

import RenderPromoteBanner from 'src/components/containers/advanced-search/render-promote-banner';

import MagnifyingGlass from 'src/assets/images/advance-search/magnifying-glass.png';
import GeneralSemanticSearch from 'src/assets/images/advance-search/general-semantic-search.png';
import GeneralSynonyms from 'src/assets/images/advance-search/general-synonyms.png';
import GeneralProductPerformanceRanking from 'src/assets/images/advance-search/general-product-performance-ranking.png';
import GeneralPersonalization from 'src/assets/images/advance-search/general-personalization.png';
import GeneralResult from 'src/assets/images/advance-search/general-result.png';
import GeneralFinalResult from 'src/assets/images/advance-search/general-final-result.png';
import GeneralTopArrow from 'src/assets/images/advance-search/general-top-arrow.png';
import GeneralBottomArrow from 'src/assets/images/advance-search/general-bottom-arrow.png';

const GeneralSearch = props => {
  const { i18n } = props;

  return (
    <div className={`BC-Page BC-Page__AdvancedSearch_General`}>
      <Page title={i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.title')}>
        <TitleHelp
          i18n={i18n}
          onAnalytics={() => history.push(routes.analytics.overviewSearch())}
          hrefUserManual={URL.AI_Powered_Search}
        />
        <Layout>
          <Layout.Section>
            <div className="heading">
              {i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.contentHeading', {
                t1: (
                  <span className="text-color">
                    {i18n.translate(
                      'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.contentHeading_t1'
                    )}
                  </span>
                )
              })}
            </div>
            <div className="search-block">
              <div className="search-block-content">
                <span className="text-color">
                  {i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.searchText')}
                </span>
                <img src={MagnifyingGlass} alt="Advanced search look up" />
              </div>
            </div>
            <div className="arrow-direction">
              <img src={GeneralTopArrow} alt="arrow" />
            </div>
            <div className="content-features">
              <div className="feature">
                <Card>
                  <img
                    className="full-width"
                    src={GeneralSemanticSearch}
                    alt={i18n.translate(
                      'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.semantic_Heading'
                    )}
                  />
                  <div className="card-content">
                    <p className="title">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.semantic_Heading'
                      )}
                    </p>
                    <p className="content">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.semantic_Description'
                      )}
                    </p>
                    <Button plain onClick={() => history.push(routes.semanticSearch.view())}>
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.semantic_Action'
                      )}
                    </Button>
                  </div>
                </Card>
              </div>
              <div className="feature">
                <Card>
                  <img
                    className="full-width"
                    src={GeneralSynonyms}
                    alt={i18n.translate(
                      'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.aiSynonyms_Heading'
                    )}
                  />
                  <div className="card-content">
                    <p className="title">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.aiSynonyms_Heading'
                      )}
                    </p>
                    <p className="content">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.aiSynonyms_Description'
                      )}
                    </p>
                    <Button plain onClick={() => history.push(routes.aiSynonym.view())}>
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.aiSynonyms_Action'
                      )}
                    </Button>
                  </div>
                </Card>
              </div>
            </div>
            <div className="arrow-direction">
              <img src={GeneralBottomArrow} alt="arrow" />
            </div>
            <div className="content-result">
              <Card title={i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.results')}>
                <img
                  className="full-width"
                  src={GeneralResult}
                  alt={i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.results')}
                />
              </Card>
            </div>
            <div className="arrow-direction">
              <img src={GeneralTopArrow} alt="arrow" />
            </div>
            <div className="content-features">
              <div className="feature">
                <Card>
                  <img
                    className="full-width"
                    src={GeneralProductPerformanceRanking}
                    alt={i18n.translate(
                      'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.productPerformanceRanking_Heading'
                    )}
                  />
                  <div className="card-content">
                    <p className="title">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.productPerformanceRanking_Heading'
                      )}
                    </p>
                    <p className="content">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.productPerformanceRanking_Description'
                      )}
                    </p>
                    <Button
                      plain
                      onClick={() => history.push(routes.productPerformanceRanking.view())}>
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.productPerformanceRanking_Action'
                      )}
                    </Button>
                  </div>
                </Card>
              </div>
              <div className="feature">
                <Card>
                  <img
                    className="full-width"
                    src={GeneralPersonalization}
                    alt={i18n.translate(
                      'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.searchPersonalization_Heading'
                    )}
                  />
                  <div className="card-content">
                    <p className="title">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.searchPersonalization_Heading'
                      )}
                    </p>
                    <p className="content">
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.searchPersonalization_Description'
                      )}
                    </p>
                    <Button plain onClick={() => history.push(routes.searchPersonalization.view())}>
                      {i18n.translate(
                        'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.searchPersonalization_Action'
                      )}
                    </Button>
                  </div>
                </Card>
              </div>
            </div>
            <div className="arrow-direction">
              <img src={GeneralBottomArrow} alt="arrow" />
            </div>
            <div className="content-final-result">
              <Card
                title={i18n.translate(
                  'AdminHTML.AdvanceSearch.GeneralAdvancedSearch.finalResults'
                )}>
                <img
                  className="full-width"
                  src={GeneralFinalResult}
                  alt={i18n.translate('AdminHTML.AdvanceSearch.GeneralAdvancedSearch.finalResults')}
                />
              </Card>
            </div>
          </Layout.Section>
          <Layout.Section>
            <RenderPromoteBanner />
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  );
};

export default withI18n()(GeneralSearch);
